export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export type HardBlockReasonType = 'LOST' | 'STOLEN' | 'DAMAGED' | 'NOT_IN_USE';

export enum HardBlockReason {
    LOST = 'LOST',
    STOLEN = 'STOLEN',
    DAMAGED = 'DAMAGED',
    NOT_IN_USE = 'NOT_IN_USE',
}

export interface BlockReorderLoader {
    isHardBlockingCard: boolean;
    hasHardBlockedCard: boolean;
    failedHardBlockingCard: boolean;
    isReorderingCard: boolean;
    hasReorderedCard: boolean;
    failedReorderingCard: boolean;
}

export interface CustomerAddress {
    address: string[];
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export interface CardInfo {
    /** Formatted card number of the selected card */
    formattedCardNumber: string;
    /** Formatted account number of the selected card */
    formattedAccountNumber: string;
}

export interface CustomerInfo {
    /** Phone number to recieve confirmation SMS */
    formattedConfirmBySmsPhoneNumber?: string | undefined;
    /** Customer address information */
    customerAddress?: CustomerAddress | undefined;
}

export enum BlockErrorMessage {
    GENERIC_ERROR = 'GENERIC_ERROR',
    REBESTILLING_KREDITTKORT_AVVIST_NEXT = 'REBESTILLING_KREDITTKORT_AVVIST_NEXT',
    REBESTILLING_KREDITTKORT_AVVIST = 'REBESTILLING_KREDITTKORT_AVVIST',
    REBESTILLING_KREDITTKORT_AVVIST_OVERTRUKKET = 'REBESTILLING_KREDITTKORT_AVVIST_OVERTRUKKET',
    KORTET_ER_OVERTRUKKET = 'KORTET_ER_OVERTRUKKET',
    REORDER_DEBIT_CARD_ALREADY_IN_PROGRESS = 'REORDER_DEBIT_CARD_ALREADY_IN_PROGRESS',
    REORDER_CREDIT_CARD_ALREADY_IN_PROGRESS = 'REORDER_CREDIT_CARD_ALREADY_IN_PROGRESS',
    CANNOT_FIND_RELATED_CARD = 'CANNOT_FIND_RELATED_CARD',
    TE_REORDER_FAIL_CARD_NOT_PRODUCED = 'TE_REORDER_FAIL_CARD_NOT_PRODUCED',
    TE_SYSTEM_ERROR = 'TE_SYSTEM_ERROR',
}

export interface HarValue<T> {
    value: T;
}

export interface Bankregnr extends HarValue<string> {
    value: string;
}

export interface Formidler {
    bankregnr: Bankregnr;
    hjemmeside: string;
    navn: string;
}

export interface Address {
    address: string[];
    city?: string;
    country?: string;
    postalCode?: string;
}

export interface Bank {
    name: string;
    registrationNumber: string;
}

export interface Customer {
    address: Address;
    bank: Bank;
    creditAccounts: string[];
    debitAccounts: string[];
    email?: string;
    mobile?: string;
    otherDebitAccounts: string[];
}

export interface PrivateCustomer extends Customer {
    firstName: string;
    lastName: string;
    number: string;
}

export enum AccountStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    OTHER = 'OTHER',
}

export interface KontoNext {
    agreementName?: string;
    balanse: number;
    formidler: Formidler;
    kontonavn: string;
    kontonummer: string;
    kredittgrense: number;
    owner?: PrivateCustomer;
    produktkode: string;
    produktnavn: string;
    status?: AccountStatus;
}
